import { sendGAEvent } from '@noths/polaris-client-google-analytics';
export var trackSearch = function trackSearch(searchTerm) {
  var trackingEvent = {
    event: 'custom_event',
    event_category: 'Header',
    event_action: 'find button search',
    event_label: searchTerm
  };
  return sendGAEvent(trackingEvent);
};
export var trackRefineSearch = function trackRefineSearch(initialSearchTerm, searchTerm) {
  var trackingEvent = {
    event: 'custom_event',
    event_category: 'Header',
    event_action: 'refine search',
    event_label: "".concat(initialSearchTerm, ":").concat(searchTerm)
  };
  return sendGAEvent(trackingEvent);
};
export var createSuggestionSearchEvent = function createSuggestionSearchEvent(searchTerm, suggestion) {
  return {
    event: 'custom_event',
    event_category: 'Header',
    event_action: "click suggested ".concat(suggestion.type === 'partner' ? 'partner' : 'search term'),
    event_label: "".concat(searchTerm, ":").concat(suggestion.name)
  };
};
export var trackSuggestionSearch = function trackSuggestionSearch(searchTerm, suggestion) {
  var trackingEvent = createSuggestionSearchEvent(searchTerm, suggestion);
  return sendGAEvent(trackingEvent);
};
export var trackSearchInteraction = function trackSearchInteraction() {
  var trackingEvent = {
    event: 'custom_event',
    event_category: 'Header',
    event_action: 'search interaction',
    event_label: '3 characters'
  };
  sendGAEvent(trackingEvent);
};